"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var site_search_1 = require("./site_search");
var reverb_site_search_suggestions_1 = require("./reverb_site_search_suggestions");
var reverb_site_search_controller_1 = require("./reverb_site_search_controller");
var ReverbSiteSearch = /** @class */ (function (_super) {
    tslib_1.__extends(ReverbSiteSearch, _super);
    function ReverbSiteSearch(props) {
        var _this = _super.call(this, props) || this;
        var recentSearches = reverb_site_search_suggestions_1.buildRecentSearches(props.recentSearches);
        _this.state = {
            recentSearches: recentSearches,
        };
        return _this;
    }
    ReverbSiteSearch.prototype.render = function () {
        return (React.createElement(site_search_1.default, { fetchSuggestions: reverb_site_search_suggestions_1.default.fetch, submitQuery: reverb_site_search_controller_1.default.submitQuery, selectSuggestion: reverb_site_search_controller_1.default.selectSuggestion, recentSearches: this.state.recentSearches, defaultValue: this.props.defaultValue, siteBanner: this.props.siteBanner, placeholderText: I18n.t('discovery.siteSearch.placeholder') }));
    };
    return ReverbSiteSearch;
}(React.Component));
exports.default = ReverbSiteSearch;
//# sourceMappingURL=reverb_site_search.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/reverb_site_search.js
// module id = SaRR
// module chunks = 20 21